<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer006" role="doc-foreword">
<p class="pl-center">This is how we know what love is: Jesus Christ laid down his life for us. And we ought to lay down our lives for our brothers and sisters.</p>
<p class="pl-citation">—1 John <span class="roman">3:16</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bible_Verse.vue?cbf50c0c